import React from 'react';
import { NavLink } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

const Sidebar = ({ isOpen, onClose, userType }) => {

    const publicLinks = [
        { to: '/dashboard', label: 'Dashboard', icon: '📍' },
        { to: '/history', label: 'History', icon: '📜' },
        { to: '/rewards', label: 'Rewards', icon: '🏆' },
        { to: '/partners', label: 'Partners', icon: '🤝' },
    ];

    const ngoLinks = [
        { to: '/ngo', label: 'Dashboard', icon: '📊' },
    ];

    const commonLinks = [
        { to: '/settings', label: 'Settings', icon: '⚙️' },
        { to: '/about', label: 'About Us', icon: 'ℹ️' },
    ];

    const links = userType === 'ngo' ? ngoLinks : publicLinks;

    const activeStyle = {
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        fontWeight: '600'
    };

    return (
        <AnimatePresence>
            {isOpen && (
                <>
                    {/* Backdrop */}
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={onClose}
                        className="fixed inset-0 bg-black bg-opacity-50 z-40"
                    />
                    {/* Sidebar */}
                    <motion.div
                        initial={{ x: '-100%' }}
                        animate={{ x: 0 }}
                        exit={{ x: '-100%' }}
                        transition={{ type: 'spring', stiffness: 300, damping: 30 }}
                        className="fixed top-0 left-0 h-full w-72 bg-black text-white shadow-lg z-50 flex flex-col"
                    >
                        <div className="p-6 border-b border-gray-700">
                            <div className="flex justify-between items-center">
                                <img src="/Copy_of_VolunGo__1_-removebg-preview - no bg.PNG" alt="Logo" className="h-8" />
                                <button onClick={onClose} className="text-gray-400 hover:text-white text-2xl">&times;</button>
                            </div>
                        </div>

                        <nav className="flex-grow p-4 space-y-2">
                            {links.map(link => (
                                <NavLink 
                                    key={link.to}
                                    to={link.to} 
                                    onClick={onClose}
                                    style={({ isActive }) => isActive ? activeStyle : undefined}
                                    className="flex items-center gap-4 p-3 rounded-lg hover:bg-gray-800 transition-colors"
                                >
                                    <span className="text-xl">{link.icon}</span>
                                    <span>{link.label}</span>
                                </NavLink>
                            ))}
                            <div className="pt-4 mt-4 border-t border-gray-700">
                                {commonLinks.map(link => (
                                     <NavLink 
                                        key={link.to}
                                        to={link.to} 
                                        onClick={onClose}
                                        style={({ isActive }) => isActive ? activeStyle : undefined}
                                        className="flex items-center gap-4 p-3 rounded-lg hover:bg-gray-800 transition-colors"
                                    >
                                        <span className="text-xl">{link.icon}</span>
                                        <span>{link.label}</span>
                                    </NavLink>
                                ))}
                            </div>
                        </nav>
                    </motion.div>
                </>
            )}
        </AnimatePresence>
    );
};

export default Sidebar;
